import React, { useEffect, useState } from "react";
import { Handshake, ChevronDown, ChevronUp } from "lucide-react";
import { api } from "../lib/api";
import { log } from "../lib/log";

function PartnerRow({ p }) {
  const [open, setOpen] = useState(false);
  const slug = p.referrer.toLowerCase().replace(/[^a-z0-9]+/g, "-");
  return (
    <li className="border border-white/5 bg-white/[0.02]" data-testid={`referral-partner-${slug}`}>
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-white/[0.03] transition-colors" data-testid={`referral-partner-toggle-${slug}`}>
        <span className="font-heading text-lg text-[#E8DFD3] truncate">{p.referrer}</span>
        <span className="flex items-center gap-4 shrink-0 text-[11px] uppercase tracking-[0.2em] text-[#A89C98]">
          <span><b className="font-mono-scanner text-[#C8A96E] text-base">{p.signups}</b> signups</span>
          <span><b className="font-mono-scanner text-[#9CBF8E] text-base">{p.paid}</b> paid</span>
          {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </span>
      </button>
      {open && (
        <ul className="px-4 pb-3 space-y-1 text-sm text-[#A89C98]" data-testid={`referral-people-${slug}`}>
          {p.people.map((u) => (
            <li key={u.email} className="flex justify-between gap-3">
              <span className="truncate">{u.name || "—"} · {u.email}</span>
              <span className={u.paid ? "text-[#9CBF8E]" : ""}>{u.paid ? "Paid" : "Free"}</span>
            </li>
          ))}
        </ul>
      )}
    </li>
  );
}

// Owner-only: who recommended each signup (free-text "Recommended by" at onboarding).
export default function ReferralsPanel() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/owner/referrals").then((r) => setData(r.data)).catch((e) => log.warn("referrals fetch failed:", e));
  }, []);
  if (!data) return null;
  return (
    <section className="glass p-5 sm:p-6 mb-5" data-testid="referrals-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#C8A96E] flex items-center gap-2"><Handshake size={12} /> Owner · Partner referrals</div>
          <h3 className="font-heading text-2xl mt-1">Who's sending people your way</h3>
        </div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#A89C98]" data-testid="referrals-totals">
          <b className="font-mono-scanner text-[#C8A96E] text-base">{data.total_signups}</b> referred · <b className="font-mono-scanner text-[#9CBF8E] text-base">{data.total_paid}</b> paid
        </div>
      </div>
      {data.partners.length === 0 ? (
        <p className="mt-4 text-sm text-[#A89C98]" data-testid="referrals-empty">No referrals yet — new users can name who recommended them during signup.</p>
      ) : (
        <ul className="mt-4 space-y-2">{data.partners.map((p) => <PartnerRow key={p.referrer} p={p} />)}</ul>
      )}
    </section>
  );
}
